import { Component } from 'react';
import { connect } from 'react-redux';
import { isGranted } from '../../utils/security';

class IfGranted extends Component {
  render() {
    const { allowedPermissions, auth: { user } } = this.props;
    if (isGranted(user, allowedPermissions)) {
      return this.props.children;
    }
    return null;
  }
}

const mapStateToProps = state => ({ auth: state.auth });
export default connect(
  mapStateToProps,
  null
)(IfGranted);
